module.exports = __webpack_public_path__ + "img/Img20_180449_BiFl-5-2AH2-5.2ca59d35.jpg";